import { render } from "./AuthContacts.vue?vue&type=template&id=c957cdea&scoped=true"
import script from "./AuthContacts.vue?vue&type=script&lang=js"
export * from "./AuthContacts.vue?vue&type=script&lang=js"

import "./AuthContacts.vue?vue&type=style&index=0&id=c957cdea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c957cdea"]])

export default __exports__